<template>
    <div :id="stepData.id" class="step_container prelative">
        <preloader :display="loading" class="preloader prelative" />

        <div class="step_header">
            <h4 class="m-0 semibold">
                {{ stepData.label }}
            </h4>
            <p
                v-if="pagination.total > 0 && totalPotential"
                class="nbOppPipeline mt-1 mb-0 semibold"
            >
                {{
                    $l10n.n__(
                        '%(count)s  affaire pour %(potential)s',
                        '%(count)s affaires pour %(potential)s',
                        pagination.total,
                        { count: pagination.total, potential: totalPotential },
                    )
                }}
            </p>
            <p class="mt-1 mb-0 regular">
                <a class="stepAutomationStatus cpointer" @click="editAutomation">
                    <span v-if="stepData.automationEnabled == 'Y'" class="gray-60">
                        {{ $l10n.__('Email automatique activé') }}
                    </span>
                    <span v-else class="gray-60">
                        {{ $l10n.__('Email automatique désactivé') }}
                    </span>
                </a>
            </p>
        </div>
        <div :id="'container_' + stepData.id" :ref="'container_' + stepData.id" class="stepCell">
            <ul :ref="'stepCellList_' + stepData.id" class="step_content stepCellList">
                <SaasDraggable
                    v-model="oppOrdered"
                    group="opportunities"
                    :useDragArea="true"
                    dragClass="opportunity-pipeline-card"
                    defaultDragZoneHeight="340px"
                    @change="onChangeCallback"
                >
                    <li
                        v-for="oneOpp in oppOrdered"
                        :key="oneOpp.id"
                        class="well well-medium opportunityList mb-2 fs-3 p-0 opportunity-pipeline-card"
                    >
                        <pipeline-card
                            ref="pipelineCard"
                            :data="oneOpp"
                            :tableDensity="tableDensity"
                            @handle-context-menu="handleShowContextMenu"
                        />
                    </li>
                </SaasDraggable>
            </ul>
        </div>
    </div>
</template>

<script>
import SaasDraggable from 'vcomponents/common/SaasDraggable.vue';
import PipelineCard from './PipelineCard.vue';
import Preloader from 'vcomponents/utilities/Preloader.vue';

export default {
    components: {
        Preloader,
        SaasDraggable,
        PipelineCard,
    },
    props: {
        listinghash: {
            type: String,
        },
        stepData: {
            type: Object,
        },
        opps: {
            type: Array,
        },
    },
    emits: ['opportunity-update', 'opportunity-update-header'],
    data() {
        return {
            oppOrdered: [],
        };
    },
    computed: {
        kpis() {
            if (this.$store.state[this.listinghash].kpis[this.stepData.id] == undefined) {
                return false;
            }

            return this.$store.state[this.listinghash].kpis[this.stepData.id];
        },

        totalPotential() {
            if (this.kpis) {
                const index = _.findIndex(this.kpis, { name: 'total_potential' });

                if (index != -1) {
                    return this.$filters.numberFormat(this.kpis[index].value, true);
                }
            }

            return false;
        },

        pagination() {
            return this.$store.state[this.listinghash].pagination[this.stepData.id];
        },

        tableDensity() {
            return this.$store.state[this.listinghash].display['density'];
        },

        loading() {
            if (!this.$store.state[this.listinghash].ajaxStep[this.stepData.id]) {
                return false;
            }
            return true;
        },
    },
    watch: {
        opps(newVal) {
            if (!_.isEqual(newVal, this.oppOrdered)) {
                // Mimic the SQL order clause
                this.oppOrdered = newVal.sort(function (a, b) {
                    const functions = [
                        // Order by rank DESC
                        (a, b) => -(parseInt(a.rank, 10) - parseInt(b.rank, 10)),
                        // Order by nbDayInCurrentStep ASC
                        (a, b) =>
                            parseInt(a.nbDayInCurrentStep, 10) - parseInt(b.nbDayInCurrentStep, 10),
                        // Order by id DESC
                        (a, b) => -(parseInt(a.id, 10) - parseInt(b.id, 10)),
                    ];

                    for (const fn of functions) {
                        const result = fn(a, b);
                        if (0 !== result) {
                            return result;
                        }
                    }

                    return 0;
                });
            }
        },
    },
    created() {
        EventBus.on('form:opportunity:edit:success', (data) => {
            if (data.stepId == this.stepData.id) {
                this.refreshStep();
            }
        });

        EventBus.on('form:opportunity:delete', (data) => {
            if (data.stepId == this.stepData.id) {
                this.refreshStep();
            }
        });
    },
    mounted() {
        this.$refs['container_' + this.stepData.id].onscroll = () => {
            const currentHeight =
                this.$refs['container_' + this.stepData.id].scrollTop +
                this.$refs['container_' + this.stepData.id].offsetHeight;
            const totalHeight = this.$refs['stepCellList_' + this.stepData.id].clientHeight;
            if (
                currentHeight >= totalHeight &&
                !this.loading &&
                !(this.pagination.total == this.oppOrdered.length)
            ) {
                this.fetchStep();
            }
        };
    },
    methods: {
        onMoveCallback(event) {
            if (event.editable === false) {
                Push.error(
                    this.$l10n.__('Vous ne disposez pas des droits nécessaires pour cette action.'),
                    null,
                    { preventDuplicates: true },
                );
                return false;
            }
            return true;
        },
        onChangeCallback(event) {
            if ('moved' in event) {
                this.onMoveCallback(event.moved);
            }
            if ('updated' in event || 'added' in event) {
                this.updateOppsRank(event);
            } else if ('removed' in event) {
                const payload = {
                    stepid: this.stepData.id,
                    rows: this.oppOrdered,
                };
                this.$store.commit(`${this.listinghash}/updateStep`, payload);
            }

            if ('added' in event || 'removed' in event) {
                this.updateKpis(event);
            }
        },
        updateOppsRank(event) {
            let oid = 0;
            if ('updated' in event) {
                oid = event.updated.id;
            } else if ('added' in event) {
                oid = event.added.id;
            }

            const self = this;
            const prevOpps = [];
            let indexNextOpp = 0;
            let newRankOpp = 0;
            const stepid = this.stepData.id;

            _.each(self.oppOrdered, function (elem, index) {
                if (elem.id == oid) {
                    indexNextOpp = index + 1;
                    return false;
                } else {
                    prevOpps.push(
                        JSON.stringify({
                            id: elem.id,
                            rank: parseInt(elem.rank) + 1,
                        }),
                    );
                    self.oppOrdered[index].rank = parseInt(elem.rank) + 1;
                }
            });

            let nextOppRank = 0;
            if (self.oppOrdered[indexNextOpp]) {
                nextOppRank = self.oppOrdered[indexNextOpp].rank;
            }
            newRankOpp = nextOppRank == 0 ? 1 : parseInt(nextOppRank) + 1;
            self.oppOrdered.find((opp) => opp.id == oid).rank = newRankOpp;

            const oldStepOpp = self.oppOrdered.find((opp) => opp.id == oid).step;
            if (stepid != oldStepOpp) {
                self.oppOrdered.find((opp) => opp.id == oid).nbDayInCurrentStep = '0';
                self.oppOrdered.find((opp) => opp.id == oid).formatted_nbDayInCurrentStep = '-';
            }

            this.$emit('opportunity-update', oid, stepid, newRankOpp, prevOpps, this.oppOrdered);
        },

        updateKpis(event) {
            let payload = {};
            if ('added' in event) {
                this.pagination.total++;
                this.kpis[1].value = parseInt(this.kpis[1].value) + parseInt(event.added.potential);
            } else if ('removed' in event) {
                this.pagination.total--;
                this.kpis[1].value =
                    parseInt(this.kpis[1].value) - parseInt(event.removed.potential);
            }
            if (Object.values(payload).length > 0) {
                payload = {
                    stepid: this.stepData.id,
                    pagination: this.pagination,
                    kpis: this.kpis,
                };
                this.$emit('opportunity-update-header', payload);
            }
        },

        fetchStep() {
            const payload = {
                page: parseInt(this.pagination.current_page, 10) + 1,
                stepid: this.stepData.id,
            };

            this.$store.commit(`${this.listinghash}/updateStepPage`, payload);
            this.$store.dispatch(`${this.listinghash}/fetchOne`, {
                step: this.stepData,
            });
        },

        refreshStep() {
            const payload = {
                page: parseInt(this.pagination.current_page, 10),
                stepid: this.stepData.id,
            };

            this.$store.dispatch(`${this.listinghash}/fetchOne`, {
                step: this.stepData,
                forcecount: true,
                kpis: true,
            });
        },

        editAutomation() {
            window.Prospection.editFunnelAutomation(this.stepData.funnelid, this.stepData.id);
        },

        handleShowContextMenu(event, id) {
            event.preventDefault();

            const contextRef = 'contextmenu' + id;
            const eventX = event.pageX;
            const eventY = event.pageY;
            let currentContextMenu = false;

            for (var i in this.$refs.pipelineCard) {
                if (this.$refs.pipelineCard[i].$refs[contextRef]) {
                    currentContextMenu = this.$refs.pipelineCard[i].$refs[contextRef];
                }
            }

            currentContextMenu.show();
            this.$nextTick(() => {
                const contextmenuPosition = {
                    top: eventY,
                    left: eventX,
                };
                const contextmenuWidth = currentContextMenu.$el.clientWidth;
                const contextmenuHeight = currentContextMenu.$el.clientHeight;
                if (contextmenuHeight + eventY >= window.innerHeight) {
                    contextmenuPosition.top -= contextmenuHeight;
                }
                if (contextmenuWidth + eventX >= window.innerWidth) {
                    contextmenuPosition.left -= contextmenuWidth;
                }
                const position = {
                    top: `${contextmenuPosition.top}px`,
                    left: `${contextmenuPosition.left}px`,
                };
                currentContextMenu.style = position;
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.step_container {
    width: 300px;
    border-right: 1px solid #ddd;
    padding: 4px 8px;
    display: flex;
    flex-direction: column;

    .opportunityList {
        overflow: hidden;
    }
}

.stepCell {
    flex: 1;
    overflow-y: auto;
}

.dragArea {
    min-height: 100px;
}
</style>
